import { setAppointmentActiveVehicle, setIsTrailer } from 'components/QuickAppointmentPage/actions'

export const changeVehicleSelectorField = userVehicleId => dispatch => {
  dispatch(setAppointmentActiveVehicle({ userVehicleId }))
  dispatch(setIsTrailer(false))
}
